import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { TreeNode } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { iAdminService } from 'src/app/core/services/iAdmin.service';
import { FolderClassificationDto } from 'src/app/shared/models/admin/classement';
import * as _ from 'underscore';

@Component({
  selector: 'app-search-classement',
  templateUrl: './search-classement.component.html',
  styleUrls: ['./search-classement.component.scss'],
})
export class SearchClassementComponent implements OnInit {
  public classements: TreeNode[] = [];
  public selectedNode: TreeNode;
  public selectedClasseur: TreeNode;
  public selectedChemise: TreeNode;
  public selectedObjetClassement: any;
  public loading: boolean = true;
  serviceId: number;
  buttonsToExpand: 'openAll' | 'closeAll' = 'openAll';

  constructor(
    public dialogRef: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public iAdminService: iAdminService,
    public toast: ToastrService,
  ) {}

  ngOnInit(): void {
    this.loading = true;
    this.serviceId = this.config.data.serviceId;
    this.getClassements(this.serviceId);
  }

  getClassements(serviceId: number): void {
    this.iAdminService
      .fetchFoldersClassification({
        SvcIds: [serviceId],
        IncludePartages: true,
        ClasseurArchived: 'Exclude',
        ChemiseArchived: 'Exclude',
      })
      .subscribe({
        next: (response: FolderClassificationDto[]) => {
          const mappedResponse: (FolderClassificationDto &
            Partial<{
              label: string;
              data: number;
              key: number;
              expandedIcon: string;
              collapsedIcon: string;
              type: string;
              children: any[];
            }>)[] = [...response];
          if (mappedResponse && mappedResponse.length > 0) {
            mappedResponse.map((item) => {
              if (item && item.actif) {
                item.label = item.code + (item.description ? ' (' + item.description + ')' : '');
                item.data = item.id;
                item.key = item.id;
                item.expandedIcon = 'pi pi-folder-open';
                item.collapsedIcon = 'pi pi-folder';
                item.type = 'classement';
                item.children = [];
                if (item.classeurs && item.classeurs.length > 0) {
                  item.classeurs.map((classeur) => {
                    if (classeur.chemises && classeur.chemises.length > 0) {
                      classeur.children = [];
                      classeur.chemises.map((chemise) => {
                        classeur.children.push({ // Chemises
                          label: chemise.description,
                          data: chemise.id,
                          key: chemise.id,
                          icon: 'pi pi-file',
                          classementId: item.id,
                          classeurId: classeur.id,
                          type: 'chemise',
                        });
                      });
                    }
                    item.children.push({ // Classeur
                      label: classeur.description,
                      data: classeur.id,
                      key: classeur.id,
                      expandedIcon: 'pi pi-folder-open',
                      collapsedIcon: 'pi pi-folder',
                      classementId: item.id,
                      type: 'classeur',
                      children: classeur.children,
                    });
                  });
                }
              }
            });
            this.classements = _.sortBy(mappedResponse, 'label');
          }
          this.loading = false;
        },
        error: (error: HttpErrorResponse) => {
          console.error('Error : ', error);
        },
      });
  }

  public onClassementSelect(event): void {
    switch (event.node.type) {
      case 'classement':
        this.selectedNode = event.node;
        this.selectedObjetClassement = {
          classementId: event.node.data,
          classeurId: null,
          chemiseId: null,
        };
        this.selectedNode.expanded = true;
        break;
      case 'classeur':
        this.selectedClasseur = event.node;
        this.selectedClasseur.expanded = true;
        this.selectedObjetClassement = {
          classementId: event.node.classementId,
          classeurId: event.node.data,
          chemiseId: null,
        };
        break;
      case 'chemise':
        this.selectedChemise = event.node;
        this.selectedObjetClassement = {
          classementId: event.node.classementId,
          classeurId: event.node.classeurId,
          chemiseId: event.node.data,
        };
        break;
    }
  }

  expandAll(): void {
    this.classements.forEach((node) => {
      this.expandRecursive(node, true);
    });
  }

  collapseAll(): void {
    this.classements.forEach((node) => {
      this.expandRecursive(node, false);
    });
  }

  collapseOrExpandAll(): void {
    if (this.buttonsToExpand === 'openAll') {
      this.expandAll();
      this.buttonsToExpand = 'closeAll';
    } else {
      this.collapseAll();
      this.buttonsToExpand = 'openAll';
    }
  }

  private expandRecursive(node: TreeNode, isExpand: boolean): void {
    node.expanded = isExpand;
    if (node.children) {
      node.children.forEach((childNode) => {
        this.expandRecursive(childNode, isExpand);
      });
    }
  }

  onSubmit(): void {
    this.dialogRef.close(this.selectedObjetClassement);
  }
}
